"use client";

import { c as _c } from "react/compiler-runtime";
import { useEnsName } from "wagmi";
interface EnsAddressDisplayProps {
  readonly address: string;
  readonly chainId?: number;
  readonly className?: string;
}
export default function EnsAddressDisplay(t0) {
  const $ = _c(20);
  const {
    address,
    chainId: t1,
    className
  } = t0;
  const chainId = t1 === undefined ? 1 : t1;
  const isValidAddress = address?.startsWith("0x") && address.length === 42;
  const t2 = isValidAddress ? address as `0x${string}` : undefined;
  let t3;
  if ($[0] !== chainId || $[1] !== t2) {
    t3 = {
      address: t2,
      chainId
    };
    $[0] = chainId;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: ensName,
    isLoading
  } = useEnsName(t3);
  if (isLoading) {
    let t4;
    if ($[3] !== address) {
      t4 = <span className="tw-animate-pulse">{address}</span>;
      $[3] = address;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== className || $[6] !== t4) {
      t5 = <span className={className}>{t4}</span>;
      $[5] = className;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  if (ensName) {
    let t4;
    if ($[8] !== ensName) {
      t4 = <span className="tw-text-primary-400">{ensName}</span>;
      $[8] = ensName;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <span className="tw-mx-1 tw-text-iron-500">-</span>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== address) {
      t6 = <span>{address}</span>;
      $[11] = address;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== className || $[14] !== t4 || $[15] !== t6) {
      t7 = <span className={className}>{t4}{t5}{t6}</span>;
      $[13] = className;
      $[14] = t4;
      $[15] = t6;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    return t7;
  }
  let t4;
  if ($[17] !== address || $[18] !== className) {
    t4 = <span className={className}>{address}</span>;
    $[17] = address;
    $[18] = className;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}